import styled from 'styled-components'

import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

const StyledWrap = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  position: absolute;
  top: ${({ show, showTop, hideTop }: any) => (show ? showTop : hideTop)}px;
  opacity: ${({ show }: any) => (show ? 1 : 0)};
  left: 0;
  right: 0;
  transition-property: top, opacity;
  transition-duration: 300ms;
  cursor: ${({ onClick }: any) => (onClick ? 'pointer' : 'default')};
  background: ${({ theme }: any) => themeUtilities.getRgbaColor(theme, 'attention')};
  color: white;
  font-size: ${({ theme }: any) => themeUtilities.getFontSize(theme, 'medium')}px;
  padding: 5px;
`

interface WarningPulldownProps {
  className?: string
  hideTop?: number
  label: string
  onClick?(...args: unknown[]): unknown
  show?: boolean
  showTop?: number
}

const WarningPulldown = ({ onClick, label, show, className, showTop, hideTop }: WarningPulldownProps) => {
  return (
    // @ts-expect-error
    <StyledWrap show={show} className={className} showTop={showTop} hideTop={hideTop} onClick={onClick}>
      {label}
    </StyledWrap>
  )
}

WarningPulldown.displayName = 'WarningPulldown'

WarningPulldown.defaultProps = {
  show: false,
  showTop: 40,
  hideTop: 0
}

export default WarningPulldown
